<template>
    <div
        :class="{ items_wrapper_item_wr: true, home: homeCard }"
        :style="style"
    >
        <router-link :to="'/movie/' + slide.id" class="items_wrapper_item">
            <img
                v-if="slide.is_season == 1"
                class="serialCart"
                src="../../assets/icons/serialCart.svg"
                alt="Tvcom"
            />

            <div class="image_wrapper">
                <img
                    :class="{
                        movie_img_class: true,
                        home: homeCard,
                        staticImg,
                    }"
                    loading="lazy"
                    :src="
                        slide.thumbnail_big
                            ? slide.thumbnail_big
                            : slide.thumbnail_small
                    "
                    alt="Tvcom"
                />
            </div>

            <div class="shildik" v-if="slide.provider == 'uzb'">
                <img
                    loading="lazy"
                    src="../../assets/icons/shildikUzb.svg"
                    alt="Tvcom"
                />
            </div>

            <div class="shildik" v-if="slide.video_provider_id == 1">
                <img
                    loading="lazy"
                    src="../../assets/icons/shildikMegogo.svg"
                    alt="Tvcom"
                />
            </div>

            <div class="shildik" v-if="slide.video_provider_id == 2">
                <img
                    loading="lazy"
                    src="../../assets/icons/shildikAmedia.svg"
                    alt="Tvcom"
                />
            </div>

            <div class="shildik" v-if="slide.video_provider_id == 4">
                <img
                    loading="lazy"
                    src="../../assets/icons/shildikStart.svg"
                    alt="Tvcom"
                />
            </div>

            <div class="shildik" v-if="slide.video_provider_id == 6">
                <img
                    loading="lazy"
                    src="../../assets/icons/shildikMore.svg"
                    alt="Tvcom"
                />
            </div>

            <div class="shildik" v-if="slide.video_provider_id == 7">
                <img
                    loading="lazy"
                    src="../../assets/icons/shikdikPremier.svg"
                    alt="Tvcom"
                />
            </div>

            <div class="shildik" v-if="slide.video_provider_id == 8">
                <div class="shildik_text">
                    <span>Riza</span><span>Nova</span>
                </div>
            </div>

            <div class="name_item_wrapper">
                <div class="black">
                    <p class="blackTitle">
                        <span
                            v-if="slide?.name?.length > 20"
                            :style="{ '--text-length': slide?.name?.length }"
                            class="scrolling-text-container"
                        >
                            <span :class="{ 'scrolling-text': true }">{{
                                (slide?.name + "" || "").split("/")[0]
                            }}</span>
                            <span :class="{ 'scrolling-text': true }">{{
                                (slide?.name + "" || "").split("/")[0]
                            }}</span>
                        </span>
                        <span v-else class="text-container">
                            {{ (slide?.name + "" || "").split("/")[0] }}
                        </span>
                        <span :class="{ ageRating: true, home: homeCard }"
                            >{{ slide?.rating || 0 }}+</span
                        >
                    </p>
                    <div>
                        <p class="movieInfo">
                            <span v-if="slide.duration && slide.duration != 0"
                                >{{ slide.duration }} мин</span
                            >
                            <span
                                v-if="slide.year != 'year не загружено'"
                                v-html="slide.year"
                            ></span>
                            <span
                                v-if="
                                    slide.countries &&
                                    slide.countries !== 'нету countries'
                                "
                                v-html="reducer(slide.countries)"
                            ></span>
                            <span v-if="slide.genres !== 'нету жанров'">{{
                                reducer(slide.genres)
                            }}</span>
                        </p>

                        <div class="rating">
                            <div
                                v-if="
                                    (slide.kinopoisk_rating !==
                                        slide.imdb_rating &&
                                        slide.kinopoisk_rating > 0) ||
                                    (slide.kinopoisk_rating ===
                                        slide.imdb_rating &&
                                        slide.kinopoisk_rating > 0)
                                "
                                :class="{
                                    ratingItem: true,
                                    transparent:
                                        slide.kinopoisk_rating == '0.0',
                                }"
                            >
                                <img
                                    class="ratingImg"
                                    src="../../assets/assets/Kinopoisk.svg"
                                />
                                <p class="ratingNumber">
                                    {{
                                        Number(slide.kinopoisk_rating).toFixed(
                                            1
                                        )
                                    }}
                                </p>
                            </div>

                            <div
                                v-if="
                                    slide.imdb_rating !==
                                        slide.kinopoisk_rating &&
                                    slide.imdb_rating > 0
                                "
                                :class="{
                                    ratingItem: true,
                                    transparent: slide.imdb_rating == '0.0',
                                }"
                            >
                                <img
                                    class="ratingImg"
                                    src="../../assets/assets/IMDB.svg"
                                />
                                <p class="ratingNumber">
                                    {{ Number(slide.imdb_rating).toFixed(1) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="gradient">
                    <p
                        class="name_wrap_item"
                        v-html="converter(slide.name)"
                    ></p>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        slide: {
            default: {},
        },
        style: { default: {} },
        homeCard: { default: true },
        staticImg: { default: false },
    },

    mounted() {},

    methods: {
        converter(name) {
            return name;
        },
        reducer(arrayString) {
            if (!arrayString) return "";
            const array = arrayString.split(",");
            if (!Array.isArray(array)) return array;
            return array.slice(0, 3).join(", ");
        },
    },
};
</script>

<style scoped>
.blackTitle {
    color: #fff;
    font-size: 18px;
    /* text-align: center; */
    margin-top: 30px;
    font-weight: 700;
    line-height: 25px;
    padding: 0 10px;
    width: 100%;
    box-sizing: border-box;
    gap: 5px;
}
.ageRating {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 3px;
    padding: 0 5px;
    font-weight: 500;
    line-height: 20px;
    font-size: 15px;
    height: min-content;
    position: absolute;
    top: 10px;
    left: 10px;
}
.ageRating.home {
    top: 10px;
    left: 10px;
}
.text-container {
    position: relative;
    display: inline-block;
    width: 100%;
    text-align: center;
    height: 100%;
    margin-top: 10px;
}
.scrolling-text-container {
    position: relative;
    width: 100%;
    display: inline-block;
    /* overflow: hidden; */
    height: 100%;
}
.scrolling-text {
    position: absolute;
    height: 100%;
    top: 14px;
    white-space: nowrap;
    /* will-change: transform; */
    --duration: calc(8s + (var(--text-length) * 0.1s));
    padding: 0 15px;
    display: inline;
    min-width: 100%;
    z-index: 1000;
}
/* Set the animation duration based on the length of the text */
.scrolling-text:nth-of-type(2) {
    transform: translateX(102%);
}
.items_wrapper_item_wr:hover .scrolling-text {
    animation: marquee var(--duration) linear infinite;
}
.items_wrapper_item_wr:hover .scrolling-text:nth-of-type(1) {
    animation-delay: calc(var(--duration) / -2);
}
@keyframes marquee {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(-100%);
    }
}
.movieInfo {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 0 10px;
    line-height: 20px;
    margin: 0;
}
.movieInfo > span {
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
}
.ratingItem {
    display: flex;
    justify-content: center;
    gap: 5px;
    align-items: center;
}
.ratingItem div {
    margin: 0;
    padding: 0;
}
.serialCart {
    width: 58px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
}
.gradient {
    height: 40%;
    width: 100%;
    background: linear-gradient(
        360deg,
        rgba(0, 0, 0, 0.8) 21.64%,
        rgba(0, 0, 0, 0) 91.79%
    );
    display: flex;
    position: absolute;
    align-items: flex-end;
    transition: 1s;
}
.name_wrap_item {
    font-family: "Suisse Intl";
    color: #fff;
    text-decoration: none;
    font-weight: 700;
    font-size: 16px;
    height: auto;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 10px;
    -webkit-transition: -webkit-transform 0.3s;
    transition: ease-in 0.3s;
}
.image_wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}
.movie_img_class {
    /* max-width: 13rem; */
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* position: absolute; */
    top: 0;
    left: 0;
    right: 0;
    background-color: #1c1c1c;
    transition: 0.3s;
}

.ratingWrapper {
    width: 35px;
    background: #1c1c1c;
    justify-content: center;
    display: flex;
    align-items: center;
    height: fit-content;
    border-radius: 7px;
    margin-top: 10px;
    padding: 3px;
    margin-right: 10px;
}
.ratingWrapper p {
    margin: 0;
    color: #e41a4b;
}
.name_item_wrapper {
    position: absolute;
    width: 100%;
    display: flex;
    height: 100%;
    transition: 0.3s;
    cursor: pointer;
    align-items: flex-end;
    top: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.name_item_wrapper::-webkit-scrollbar {
    display: none;
}
.rating {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
    gap: 15px;
    justify-content: center;
    box-sizing: border-box;
}

.ratingImg {
    width: 23px;
    height: 23px;
}
.ratingNumber {
    /* font-family: "Suisse Intl"; */
    font-size: 30px;
    font-weight: 400;
    margin: 0;
}
.startMovie {
    width: 40px;
    height: 40px;
    position: absolute;
    top: -80px;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: auto;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
}
.black {
    padding: 10px;
    display: flex;
    flex-direction: column;
    opacity: 0;
    transition: 0.3s;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    z-index: 3;
    box-sizing: border-box;
}
.name_wrap {
    display: flex;
    justify-content: flex-end;
    width: 200px;
    position: relative;

    transition: 0.3s;
    flex-direction: column;
    height: 300px;
}
.items_wrapper_item {
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.items_wrapper_item_wr.home {
    aspect-ratio: 2/3;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    transition: 0.3s;
    max-height: 350px;
    width: 100%;
}
.items_wrapper_item_wr:hover {
    transform: scale(1.1) translateZ(10px);
    z-index: 100;
    overflow: hidden;
}
.items_wrapper_item_wr:hover .movie_img_class {
    transform: scale(1.1) translateZ(10px);
    filter: blur(8.5px) brightness(0.5);
    -webkit-filter: blur(8.5px) brightness(0.5);
}
.items_wrapper_item_wr:hover .shildik {
    display: none;
}
.items_wrapper_item_wr:hover .name_wrap_item {
    opacity: 0 !important;
}

.items_wrapper_item_wr:hover .black {
    opacity: 1;
}

.items_wrapper_item_wr:hover .gradient {
    opacity: 0;
    transition: none;
}
.ratingWrapper p {
    margin: 0;
}
.filter_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.filter_content img {
    width: 40px;
    height: 40px;
    cursor: pointer;
}
.black h3 {
    margin: 0 0px 0 10px;
}
.wraperCard {
    position: relative;
    height: 300px;
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: 0.3s;
}
.active {
    background-color: #e41a4b !important;
}
.shildik {
    position: absolute;
    top: 10px;
    left: -5px;
}
.shildik_text {
    padding: 5px 13px;
    font-size: 13px;
    background: #313131;
}

.shildik_text > span:first-child {
    font-weight: 600;
}

.shildik img {
    max-width: 90px;
}
@media (max-width: 800px) {
    /* .items_wrapper_item_wr.home {
        width: 183px;
    } */
}
</style>
